import { render, staticRenderFns } from "./singleText.vue?vue&type=template&id=ee5d0394"
import script from "./singleText.vue?vue&type=script&lang=js"
export * from "./singleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports